import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from 'src/common/constants';

const startLoadingDownloadServiceRequestCSV = () => {
  return {
    loading: true,
    loadingDone: false,
    serviceRequestList: [],
  };
};
const stopLoadingDownloadServiceRequestCSV = (csvExport) => {
  return {
    ...csvExport,
    ...{
      loading: false,
      loadingDone: false,
    },
  };
};

const initialState = {
  loading: false,
  loadingDone: false,
  serviceRequestList: [],
  serviceRequestPDFDownloadList: [],
};
export default createReducer(initialState, {
  [TYPES.START_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV]:
    startLoadingDownloadServiceRequestCSV,
  [TYPES.STOP_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV]:
    stopLoadingDownloadServiceRequestCSV,
});
